
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Dialog,
  Upload,
} from 'element-ui';
import api from '@/api/org';

@Component({
  components: {
    Dialog,
    Upload,
  },
})

export default class uploadModal extends Vue {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '附件上传',
  }) title!: string;

  @Prop({
    required: false,
  }) row!: any;

  private fileList:any = [];

  private dialogVisible:boolean = false;

  private dialogImageUrl:string = '';

  mounted() {
    this.getAttachment();
  }

  /**
   * @author liangyongmou
   * @desc 获取所有合同图片
   */
  getAttachment() {
    api.getAttachment({ contractPid: this.row.pid }).then((res: any) => {
      this.fileList = res.map((em: any) => ({ pid: em.pid, url: em.attachmentPath }));
    });
  }

  /**
   * @author liangyongmou
   * @desc 打开图片查看
   * @param { any } file 当前上传的图片
   */
  handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }

  /**
   * @author liangyongmou
   * @desc 上传之前事件
   * @param { any } file 当前上传的图片
   */
  handleBeforeUpload(file: any) {
    const data:FormData = new FormData();
    data.append('file', file);
    data.append('contractPid', this.row.pid);
    api.addAttachment(data).then((res: any) => {
      this.getAttachment();
    });
  }

  /**
   * @author liangyongmou
   * @desc 删除之前事件
   * @param { any } file 当前上传的图片
   */
  handleRemove(fileList: any) {
    const ids: string[] = [];
    ids.push(fileList.pid);
    api.removeAttachment({ ids }).then((res: any) => {
      this.getAttachment();
    });
  }

  // 重置表单
  reset(close: boolean = false) {
    if (close) this.$emit('update:visible', false);
  }
}
